var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 231,
    viewBox: "0 0 214 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.558 188.224L49.8351 213.001L0.146484 28.0625V230.002H202.639L156.043 183.533C151.729 185.399 147.231 186.976 142.558 188.224Z",
    fill: "#939999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.436 70.9786C196.714 19.9101 144.078 -10.3989 92.8691 3.28592L0.146484 28.0623L78.523 106.224L210.436 70.9786Z",
    fill: "#D2D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.053 183.532C198.955 164.963 222.916 117.386 210.446 70.9785L78.5371 106.229L156.053 183.532Z",
    fill: "#939999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.558 188.224C147.231 186.976 151.734 185.399 156.043 183.533L78.523 106.225L0.146484 28.0625L49.8351 213.001L142.558 188.224Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultLogo);
export default __webpack_public_path__ + "static/media/default-logo.c59c9c00e12b2c06f8c0e4969b9dd92d.svg";
export { ForwardRef as ReactComponent };